import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { ImageSlide } from "../components/ImageGallery/types";
import { HgsImageGallery } from "../components/ProductDetail/product-image-gallery";

/**
 * This file sets up the product image gallery for React.
 * It does so by retrieving all images in the gallery (from the DOM)  and then adds them to the HgsImageGallery react component
 */

/**
 * Creates image slides js objects from a list of <img> elements.
 * @param images
 * @returns
 */
function parseImageGallery(images: NodeListOf<Element>): ImageSlide[] {

  const imageSlides: ImageSlide[] = [];

  images.forEach((img) => {
    const original = img.getAttribute("src") || "";
    const thumbnail = img.getAttribute("thumbnail") || original; // Defaults to original if not set
    const originalAlt = img.getAttribute("alt") || "";
    const thumbnailLabel = img.getAttribute("thumbnailLabel") || "";
    const thumbnailTitle = img.getAttribute("thumbnailTitle") || thumbnailLabel;

    imageSlides.push({
      original,
      thumbnail,
      originalAlt,
      thumbnailAlt: originalAlt, // Assuming same alt text if no separate thumbnail alt
      thumbnailLabel: thumbnailLabel,
      thumbnailTitle: thumbnailTitle,
    });
  });

  return imageSlides;
}
        

/**
 * Gets all <img> elements and binds them (after transform) to a react component
 */
const setupProductImageGallery = () => {
  const searchRoot = document.getElementById(
    "product-img-gallery"
  ) as HTMLElement;

  if (searchRoot) {
    const parser = new DOMParser();

    const imageElements = searchRoot.querySelectorAll("img");
    const images = parseImageGallery(imageElements);

    const root = ReactDOM.createRoot(searchRoot);

    root.render(<HgsImageGallery items={images}></HgsImageGallery>);
  }
};

setupProductImageGallery();
